import { Icon } from '@iconify/react';
import { isNativePlatform } from '@/utils/capacitor';

export type StatistikExportBusy = 'download' | 'share' | null;

interface StatistikExportActionsProps {
  busy: StatistikExportBusy;
  onDownload: () => void;
  onShare: () => void;
  onClose: () => void;
}

export function StatistikExportActions({
  busy,
  onDownload,
  onShare,
  onClose,
}: StatistikExportActionsProps) {
  const disabled = busy !== null;
  const showShare = isNativePlatform();

  return (
    <div className="flex flex-col gap-2.5 pt-1">
      <div className={showShare ? 'flex gap-2.5' : undefined}>
        <button
          type="button"
          onClick={onDownload}
          disabled={disabled}
          className={
            showShare
              ? 'h-12 min-w-0 flex-1 rounded-full border border-gray-200 bg-white text-gray-800 font-bold text-sm flex items-center justify-center gap-1.5 hover:bg-gray-50 active:scale-98 transition-all cursor-pointer disabled:opacity-50'
              : 'h-12 rounded-full bg-[#FC480D] hover:bg-[#D83B08] text-white font-bold text-sm flex items-center justify-center gap-2 w-full transition-all shadow-md active:scale-98 cursor-pointer disabled:opacity-50'
          }
        >
          {busy === 'download' ? (
            <>
              <Icon icon="ph:spinner-bold" className="w-5 h-5 animate-spin shrink-0" />
              <span className="truncate">Mengunduh...</span>
            </>
          ) : (
            <>
              <Icon icon="ph:download-simple-bold" className="w-5 h-5 shrink-0" />
              <span className="truncate">{showShare ? 'Download' : 'Download Statistik'}</span>
            </>
          )}
        </button>

        {showShare ? (
          <button
            type="button"
            onClick={onShare}
            disabled={disabled}
            className="h-12 min-w-0 flex-1 rounded-full bg-[#FC480D] hover:bg-[#D83B08] text-white font-bold text-sm flex items-center justify-center gap-1.5 shadow-md active:scale-98 transition-all cursor-pointer disabled:opacity-50"
          >
            {busy === 'share' ? (
              <Icon icon="ph:spinner-bold" className="w-5 h-5 animate-spin shrink-0" />
            ) : (
              <Icon icon="ph:share-network-bold" className="w-5 h-5 shrink-0" />
            )}
            <span className="truncate">Bagikan</span>
          </button>
        ) : null}
      </div>

      <button
        type="button"
        onClick={onClose}
        disabled={disabled}
        className="h-11 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold text-sm transition-all w-full cursor-pointer disabled:opacity-50"
      >
        Tutup
      </button>
    </div>
  );
}
